import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        occurrence: '='
    },
    template: `
        <div class="modal-header" id="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'user.Add employee' | translate }}</h2>
        </div>
        <div class="modal-body">
            <ul class="tabs01">
                <li>
                    <a ng-click="vm.changeTab('targets')"
                        ng-class="{ active: vm.activeTab === 'targets' }"
                    >{{ 'user.Based on targets' | translate }}</a>
                </li>
                <li>
                    <a ng-click="vm.changeTab('customized')"
                    ng-class="{ active: vm.activeTab === 'customized' }"
                    >{{ 'user.Customized' | translate }}</a>
                </li>
                <!-- <li>
                    <a ng-click="vm.changeTab('enrolled')"
                    ng-class="{ active: vm.activeTab === 'enrolled' }"
                    >{{ 'user.Enrolled' | translate }}</a>
                </li> -->
            </ul>
            <div ng-if="vm.showNavigationError && vm.showAddButton" class="alert alert-danger"
            >{{ 'occurrence.employee.error' | translate }}</div>
            <div class="form">
                <form-row error="vm.error">
                    <form-row-error></form-row-error>
                </form-row>
            </div>
            <modals-courses-occurrence-employee-targets
                ng-if="vm.activeTab === 'targets' && !vm.loading"
                occurrence="vm.occurrence"
                user-ids="vm.userIds"
                classifiers="vm.classifiers"
                show-navigation-error="vm.showNavigationError"
                show-add-button="vm.showAddButton"
                ng-class="{true: 'loader01', false: ''}[vm.saving]"
            />
            <modals-courses-occurrence-employee-customized
                ng-if="vm.activeTab === 'customized' && !vm.loading"
                occurrence="vm.occurrence"
                user-ids="vm.userIds"
                classifiers="vm.classifiers"
                show-navigation-error="vm.showNavigationError"
                show-add-button="vm.showAddButton"
            />
            <!-- <modals-courses-occurrence-employee-enrolled
                ng-if="vm.activeTab === 'enrolled' && !vm.loading"
                occurrence="vm.occurrence"
                user-ids="vm.userIds"
                classifiers="vm.classifiers"
                show-navigation-error="vm.showNavigationError"
                show-add-button="vm.showAddButton"
            /> -->
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button
                        ng-if="vm.showAddButton"
                        ng-class="{true: 'loading', false: ''}[vm.saving]"
                        ng-disabled="vm.saving"
                        class="btn main"
                        type="button"
                        ng-click="vm.confirmPlanningAndSave()"
                    >{{ 'general.Add' | translate }}</button>
                </li>
                <li>
                    <button
                        class="btn discrete"
                        type="button"
                        ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, ModalService, ListFactory,
                 ClassifierResource, OccurrenceResource, CourseResource, UserResource) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.ModalService = ModalService;
        this.ListFactory = ListFactory;
        this.ClassifierResource = ClassifierResource;
        this.OccurrenceResource = OccurrenceResource;
        this.CourseResource = CourseResource;
        this.UserResource = UserResource;
        this.saving = false;
    }

    $onInit () {
        this.activeTab = 'targets';
        this.initDefaultValues();
        this.loading = true;
        this.ClassifierResource.query({ pageSize: 0 }).$promise
            .then(classifiers => {
                this.classifiers = classifiers;
                this.loading = false;
            });

        this.OccurrenceResource.getParticipants(
            {
                'siteIds[]': this.occurrence.sites.map(site => site.id),
                includeOtherSiteEmployees: true,
                pageSize: 0,
                privilegesCheck: 0
            },
            { occurrenceId: this.occurrence.id }
        ).$promise.then((participants) => {
            this.participantsCount = participants.map(participant => participant.userId).length;
        });
    }

    changeTab (tab) {
        if (this.showAddButton) {
            this.showNavigationError = true;
        }
        else {
            this.activeTab = tab;
            this.initDefaultValues();
        }
    }

    initDefaultValues () {
        this.userIds = [];
        this.showNavigationError = false;
        this.showAddButton = false;
    }

    confirmPlanningAndSave () {
        this.UserResource.plannedUsers({
            courseId: this.occurrence.courseId,
            compareUserIds: this.userIds
        }).$promise.then(users => {
            if (users.length) {
                const plannedUsers = users.map(user => user.displayName).join(', ');
                const message = this.$translate.instant('planning.planned_users_message', {
                    planned_users: plannedUsers
                });
                this.ModalService.confirm(message, 'medium').then(() => this.confirmCapacityAndSave());
            }
            else {
                this.confirmCapacityAndSave();
            }
        });
    }

    confirmCapacityAndSave () {
        const employeeCount = this.participantsCount + this.userIds.length;
        if (this.occurrence.capacity && employeeCount > this.occurrence.capacity) {
            const message = this.$translate.instant('planning.capacity_over_message', {
                added_employee_count: employeeCount,
                capacity: this.occurrence.capacity
            });
            this.ModalService.confirm(message, 'medium').then(() => this.save());
        }
        else {
            this.save();
        }
    }

    save () {
        this.saving = true;
        this.error = false;

        this.OccurrenceResource.addParticipants({ id: this.occurrence.id, validateOnly: true }, { ids: this.userIds }).$promise
            .then(() => {
                this.doSave();
            })
            .catch((errors) => {
                this.saving = false;
                this.showAddButton = true;
                const notification = this.lodash.find(errors.data, (error) => error.field === 'CAPACITY_OUT_OF_RANGE_NOTIFICATION');
                document.getElementById('modal-header').scrollIntoView();

                if (notification && errors.data.length === 1) {
                    this.ModalService
                        .confirm(notification.message, 'medium')
                        .then(() => this.doSave())
                        .catch(() => this.doSave());
                }
                else {
                    const generalError = this.lodash.find(errors.data, (error) => error.field !== 'CAPACITY_OUT_OF_RANGE_NOTIFICATION');
                    this.error = generalError.message;
                }
            });
    }

    doSave (confirmAutoAdd = true) {
        const additionalParams = confirmAutoAdd ? { confirmAutoAdd } : {};

        this.OccurrenceResource.addParticipants(this.lodash.merge({ id: this.occurrence.id }, additionalParams), { ids: this.userIds }).$promise
            .then(() => this.uibModalInstance.close())
            .catch((error) => {
                this.showAddButton = true;
                this.error = this.lodash.get(error.data, '[0].message');
                // window.scrollTo() is not working here
                // use native js scrollIntoView() instead
                document.getElementById('modal-header').scrollIntoView();
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/employee/index.js